import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full h-[calc(100vh-52px)] flex" }
const _hoisted_2 = {
  key: 0,
  class: "w-[190px] mt-10 flex flex-col items-center gap-3"
}
const _hoisted_3 = {
  key: 1,
  class: "min-w-[190px] w-[190px]"
}
const _hoisted_4 = { class: "w-full" }

import InstallerProfile from "@/components/installer/InstallerProfile.vue";
import InlineLoader from "@/components/Loaders/InlineLoader.vue";
import SecondaryPageHeader from "@/components/PageHeader/SecondaryPageHeader.vue";
import InstallersSidemenu from "@/components/Sidebar/installer/InstallersSidemenu.vue";
import MainLayout from "@/layouts/MainLayout.vue";
import { useUserStore } from "@/stores/user";
import { InstallerDetails, Worker } from "@/types";
import client from "@/utils/axios";
import { computed, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";

// Route

export default /*@__PURE__*/_defineComponent({
  __name: 'InstallerProfileView',
  setup(__props) {

const route = useRoute();
const installerDetails = ref<InstallerDetails | null>(null);

// Store
const userStore = useUserStore();

// Refs
const workers = ref<Worker[]>([]);
const selectedWorker = ref<string | null>(null);
const selectedMonths = ref<Record<string, { month: number; year: number }>>({});
const isLoading = ref<boolean>(false);

// Functions
const getAllInstallers = async () => {
  isLoading.value = true;
  try {
    const response = await client.get("/installers");
    workers.value = response.data;
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

const getInstallerDetails = async () => {
  try {
    isLoading.value = true;
    const response = await client.get(
      `/installers/${route.params.id}?locale=${currentLanguage.value}`
    );
    isLoading.value = false;
    installerDetails.value = response.data;
  } catch (error) {
    console.log(error);
    isLoading.value = false;
  }
};

const handleSelectWorker = (workerId: string) => {
  if (selectedWorker.value === workerId) {
    selectedWorker.value = null;
  } else {
    selectedWorker.value = workerId;

    if (!selectedMonths.value[workerId]) {
      selectedMonths.value[workerId] = {
        month: new Date().getMonth(),
        year: new Date().getFullYear(),
      };
    }
  }
};

const handleSelectMonth = (workerId: string, month: number, year: number) => {
  selectedMonths.value[workerId] = { month, year };
};

// Computed properties
const selectedWorkerProfile = computed(() => {
  return workers.value.find((item: Worker) => item.id === route.params.id);
});

const currentLanguage = computed(() => userStore.language);
let lastDatabaseTranslationUpdateTimestamp = computed(
  () => userStore.translationsUpdateTimestamp
);

// Watchers
watch(selectedWorkerProfile, (newValue?: Worker) => {
  if (newValue) {
    handleSelectWorker(newValue.id);
  }
});

watch(
  currentLanguage,
  async (newLang: string, oldLang?: string) => {
    if (newLang && oldLang && newLang !== oldLang) {
      await getInstallerDetails();
    }
  },
  { immediate: true }
);

watch(
  lastDatabaseTranslationUpdateTimestamp,
  async (newTimestamp: number, oldTimestamp?: number) => {
    if (newTimestamp && oldTimestamp && newTimestamp !== oldTimestamp) {
      await getInstallerDetails();
    }
  },
  { immediate: true }
);

watch(
  () => route.params.id as string,
  (newId: string, oldId: string) => {
    if (newId !== oldId) {
      getInstallerDetails();
      handleSelectWorker(newId);
    }
  }
);

// Lifecycle hooks
onMounted(() => {
  getAllInstallers();
  getInstallerDetails();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MainLayout, null, {
    default: _withCtx(() => [
      _createVNode(SecondaryPageHeader, {
        "is-installer-profile": true,
        "selected-worker-profile": selectedWorkerProfile.value
      }, null, 8, ["selected-worker-profile"]),
      _createElementVNode("div", _hoisted_1, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(InlineLoader),
              _createVNode(InlineLoader),
              _createVNode(InlineLoader),
              _createVNode(InlineLoader)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (installerDetails.value)
                ? (_openBlock(), _createBlock(InstallersSidemenu, {
                    key: 0,
                    workers: workers.value,
                    "selected-months": selectedMonths.value,
                    "installer-details": installerDetails.value,
                    onSelectWorker: handleSelectWorker,
                    onSelectReport: handleSelectMonth
                  }, null, 8, ["workers", "selected-months", "installer-details"]))
                : _createCommentVNode("", true)
            ])),
        _createElementVNode("div", _hoisted_4, [
          (!isLoading.value)
            ? (_openBlock(), _createBlock(InstallerProfile, {
                key: 0,
                "worker-name": installerDetails.value?.worker?.fullname,
                "worker-role": installerDetails.value?.worker?.role,
                "completed-termins": installerDetails.value?.completedTermins,
                "completed-termins-percentage": 
            installerDetails.value?.completedTerminsPercentage
          ,
                termins: installerDetails.value?.installationTermins,
                "worker-image": installerDetails.value?.worker?.image,
                "is-report": false
              }, null, 8, ["worker-name", "worker-role", "completed-termins", "completed-termins-percentage", "termins", "worker-image"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})